import { useCallback } from 'react'
import {
  CloudUploadPlugin,
  TextEditor as Editor,
  TextEditorHeader as Header
} from 'ui-components'
import { useAuth } from 'user-auth'
import { createPresignedPostUpload } from 'utils'

import { createGetReadmeAssetsUploadUrl } from '~map-preview/api/createGetReadmeAssetsUploadUrl'
import { useMapId, useReadmeNodes } from '~map-preview/states/map'

import { Footer } from './Footer'

function TextEditor(props) {
  const { isOpenByDefault = false } = props
  const mapId = useMapId()
  const nodes = useReadmeNodes()

  const { token } = useAuth()

  /**
   * createFileUpload must return upload and abort so
   * the text editor could use those function when create a new image,
   * and abort image upload.
   */
  const createFileUpload = useCallback(
    (file: File) => {
      if (!token) throw new Error('Token is required')

      const uploadController = new AbortController()

      const getReadmeAssetsUploadUrl = createGetReadmeAssetsUploadUrl({
        mapId,
        contentType: file.type
      })

      return {
        upload: async (config) => {
          // presignedPost is a AWSJSON! and need to convert to json object
          const { path, presignedPost } = await getReadmeAssetsUploadUrl.promise

          const upload = createPresignedPostUpload(JSON.parse(presignedPost))

          await upload(file, {
            signal: uploadController.signal,
            ...config
          })

          return { path }
        },

        abort: () => {
          uploadController.abort()
          getReadmeAssetsUploadUrl.abort()
        }
      }
    },
    [mapId, token]
  )

  return (
    <Editor
      autoFocus
      sx={{ flex: 1 }}
      initialValue={nodes}
      slots={{
        Header,
        Footer
      }}
      plugins={[
        CloudUploadPlugin({
          options: {
            createFileUpload
          }
        })
      ]}
      slotProps={{
        Footer: {
          isOpenByDefault
        }
      }}
    />
  )
}

export { TextEditor }
